// @ts-nocheck
import { downloadCSV } from 'react-admin';
import jsonExport from 'jsonexport/dist';

const LocationDetailsExport = (records) => {
    const dataForExport = records.map(record => {
        const {
            id,	kegUuid, kegTurnUuid, locationRole, locationUuid,

            ...dataForExport } = record; // omit unecessary fields
        // dataForExport.fieldName = record.field.name; // add a field

        return dataForExport;
    });

    jsonExport(dataForExport, {
        headers: [
            'organisationName', 'locationName', 'locationLatitude', 'locationLongitude', 'kegsAtLocation', 'locationState', 'likelyToBeEmpty', 'kegAvgDays', 'locationType',

        ], // order fields in the export
        rename:[
            'Organisation', 'Location', 'Latitude', 'Longitude', 'Kegs At Location', 'State', 'Ready For Collection', 'Keg Average Days', 'Location Type'
        ]
    }, (err, csv) => {
        let today = new Date();
        downloadCSV(csv, 'LocationDetails_' + today.toISOString().split('T')[0]); // download as 'posts.csv` file
    });

};

export default LocationDetailsExport;
